var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MjHeader"},[_c('div',{attrs:{"id":"hem"}}),_vm._v(" "),_c('three-cols',{staticClass:"cols"},[_c('router-link',{attrs:{"to":{ name: 'Landing'}}},[_c('h1',[_c('span',{staticClass:"h1"},[_vm._v("MIK-jam")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cee5c250","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MjHeader.vue
// module id = null
// module chunks = 